import type { FormDataOf } from '../../../../types/templates';
import { macroSacaTuTarjeta } from '..';
import { isFormattedText } from '../../../../utils';
import { getMaxLinesForVariant } from './get-max-lines';

type FormData = FormDataOf<typeof macroSacaTuTarjeta>;

export const validateForm = (formData: FormData): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (formData.claim && isFormattedText(formData.claim)) {
    const { stage, adChannel, variant } = formData;

    if (stage && adChannel && variant) {
      const maxLines = getMaxLinesForVariant(stage, adChannel, variant);
      const actualLines = (formData.claim as { numberOfLines?: number }).numberOfLines || 0;

      if (actualLines > maxLines) {
        errors.claim = `El claim debe tener máximo ${maxLines} líneas (actualmente tiene ${actualLines})`;
      }
    }
  }

  if (formData.subheadline) {
    const lines = formData.subheadline.split('\n').filter(l => l.trim().length > 0);
    if (lines.length > 2) {
      errors.subheadline = `La bajada debe tener máximo 2 líneas (actualmente tiene ${lines.length})`;
    }
  }

  return errors;
};
